module.exports = "/static/js/8c821e7fdffa79dfa4a83df47e4bdf3d.png";